import "./documents.css";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TitleBox from "../../components/TitleBox/TitleBox";
import { documents } from "../../assets/docs";
import { aboutImages } from "../../assets/images/aboutImg";
import { referancesHeaderImg } from "../../assets/images/referances";

function Documents() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("policy");
  const activeTitle =
    activeTab === "policy"
      ? t("quality_tab_policy")
      : t("quality_tab_documents");

  return (
    <div className="documents-container">
      <div className="documents-header">
        <div className="header-back-img">
          <img
            src={referancesHeaderImg.referancesHeaderBack}
            alt="header-img"
          />
        </div>

        <div className="front-container">
          <div className="header-title">
            <TitleBox title={activeTitle} />
          </div>

          <div className="quality-layout">
            <div className="quality-content">
              {activeTab === "policy" && (
                <section className="quality-policy-section">
                  <div className="quality-policy-card">
                    <img
                      src={aboutImages.payeLogo}
                      alt="Paye Plast"
                      className="quality-policy-logo"
                    />
                    <h2>{t("about_quality-policy_title")}</h2>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("about_quality-policy_text1"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("about_quality-policy_text2"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("about_quality-policy_text3"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("about_quality-policy_text4"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("about_quality-policy_text5"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("about_quality-policy_text6"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("about_quality-policy_text7"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("about_quality-policy_text8"),
                      }}
                    ></p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("about_quality-policy_text9"),
                      }}
                    ></p>

                    <div className="quality-policy-signature">
                      <h3>PAYE PLAST SAN.VE TİC.AŞ.</h3>
                      <p>{t("about_quality-policy_manager_text")}</p>
                      <p>ORHAN KUŞ</p>
                      <p>28.07.2025</p>
                    </div>
                  </div>
                </section>
              )}

              {activeTab === "documents" && (
                <>
                  <div className="documents-grid">
                    {documents.map((doc) => (
                      <article className="document-card" key={doc.id}>
                        <div className="document-preview">
                          <img src={doc.preview} alt={t(doc.titleKey)} />
                          <div className="document-overlay">
                            <a
                              className="document-action"
                              href={doc.pdf}
                              target="_blank"
                              rel="noreferrer"
                              aria-label={`${t(doc.titleKey)} ${t(
                                "documents_preview"
                              )}`}
                            >
                              {t("documents_preview")}
                            </a>
                            <a
                              className="document-action secondary"
                              href={doc.pdf}
                              download={doc.downloadName}
                              aria-label={`${t(doc.titleKey)} ${t(
                                "documents_download"
                              )}`}
                            >
                              {t("documents_download")}
                            </a>
                          </div>
                        </div>

                        <div className="document-info">
                          {/*
                          <span className="document-tag">{t(doc.tagKey)}</span>
                          <h4>{t(doc.titleKey)}</h4>
                          <p>{t(doc.descriptionKey)}</p>
                          */}
                          <div className="document-actions">
                            <a
                              className="document-action"
                              href={doc.pdf}
                              target="_blank"
                              rel="noreferrer"
                              aria-label={`${t(doc.titleKey)} ${t(
                                "documents_preview"
                              )}`}
                            >
                              {t("documents_preview")}
                            </a>
                            <a
                              className="document-action secondary"
                              href={doc.pdf}
                              download={doc.downloadName}
                              aria-label={`${t(doc.titleKey)} ${t(
                                "documents_download"
                              )}`}
                            >
                              {t("documents_download")}
                            </a>
                          </div>
                        </div>
                      </article>
                    ))}
                  </div>
                </>
              )}
            </div>

            <aside className="quality-tabs" aria-label={t("documents")}>
              <div className="quality-tabs-title">{t("quality_panel_title")}</div>
              <button
                type="button"
                className={`quality-tab-button ${
                  activeTab === "policy" ? "active" : ""
                }`}
                onClick={() => setActiveTab("policy")}
              >
                {t("quality_tab_policy")}
              </button>
              <button
                type="button"
                className={`quality-tab-button ${
                  activeTab === "documents" ? "active" : ""
                }`}
                onClick={() => setActiveTab("documents")}
              >
                {t("quality_tab_documents")}
              </button>
            </aside>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Documents;
